import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import { PLACEHOLDER_ALBUM } from "@/services/mediaService";

type Props = {
  artworkUrl?: string;
  title?: string;
  onClick?: () => void;
};

const ArtworkView: React.FC<Props> = ({ artworkUrl, title, onClick }) => {
  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Box
      onClick={!isMobile ? onClick : undefined}
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        p: 0,
        m: 0,
        boxSizing: "border-box",
        backgroundColor: "transparent",
        overflow: "hidden",
      }}
    >
      <Box
        component="img"
        src={artworkUrl || PLACEHOLDER_ALBUM}
        alt={title || "Album Artwork"}
        sx={{
          width: "100%",
          height: "100%",
          objectFit: "cover", // fill box entirely
          display: "block",
          border: "none",
          outline: "none",
          borderRadius: "0px", // remove any rounding to match modal shape
          cursor: !isMobile ? "pointer" : "default",
        }}
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          target.src = PLACEHOLDER_ALBUM;
        }}
      />
    </Box>
  );
};

export default ArtworkView;










